import type {
  UserGetRecentlyVisitedProjectsParams,
  UserListProjectsParams,
} from '../api'
import { api } from '../api'

const getListProjects = async (data: UserListProjectsParams) => {
  return await api.v1.userListProjects(data)
}

const getProjectDetails = async (token: string) => {
  return await api.v1.userGetProjectDetails({ token })
}

const getRecentlyVisitedProjects = async (
  data: UserGetRecentlyVisitedProjectsParams,
) => {
  return await api.v1.userGetRecentlyVisitedProjects(data)
}

const getProjectCertDetails = async (token: string) => {
  return await api.v1.userGetProjectCertDetails({ token })
}

export default {
  getListProjects,
  getProjectDetails,
  getProjectCertDetails,
  getRecentlyVisitedProjects,
}
